module.exports = __webpack_public_path__ + "r-v3/img/upload_blue.517be24e.svg";